import * as React from 'react';
import * as Redux from 'react-redux';
import { Grid, TextField, Typography } from '@mui/material';
import * as CONST from '../../../../constants/FieldsConst';
import Box from '@mui/material/Box';
import {
  saveOperadorasAction,
  setActivoOperadorasAction,
} from '../OperadorasAction';
import { validMessage } from '../../../../constants/ValidsFormConst';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { SnackbarAlertWidget, LoadingWidget } from '../../../../widgets';
import { FormControl } from '@mui/material';
import { InputLabel } from '@mui/material';
import { Select } from '@mui/material';
import { MenuItem } from '@mui/material';

const FormOperadoras = () => {
  const dispatch = Redux.useDispatch();

  const operadorasStore = Redux.useSelector((state) => state.operadoras);

  const activo = operadorasStore.activo;

  const initData = {
    nombre: '',
    prefijo: '',
    estatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nombre: false,
    prefijo: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;

    const fetchData = () => {
      let values = {};
      Object.keys(data).map((key) => (values[key] = activo[key]));
      setTimeout(
        () =>
          setData({
            ...values,
            estatus: activo.estatus?.id ?? 2,
          }),
        300,
      );
    };

    fetchData();
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (await _validDataForm()) {
      setLoadingSave(true);
      const res = await saveOperadorasAction(
        dispatch,
        activo?.id,
        data,
        operadorasStore.params,
      );
      if (res) clearData();
      setLoadingSave(false);
    }
  };

  function clearData() {
    setActivoOperadorasAction(dispatch, null);
    setData(initData);
  }

  return (
    <Box component="form" sx={{ m: 2 }}>
      <SnackbarAlertWidget alert={operadorasStore.alertForm} />
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          <Typography variant="h6">
            {activo ? 'Editar perfil' : 'Crear'}
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nombre.name}
            required
            label={CONST.nombre.label}
            value={data.nombre}
            onChange={(e) =>
              _handleSetDataField(CONST.nombre.name, e.target.value)
            }
            helperText={dataError.nombre ? validMessage.required : null}
            error={dataError.nombre}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.prefijo.name}
            required
            label={CONST.prefijo.label}
            value={data.prefijo}
            onChange={(e) =>
              _handleSetDataField(CONST.prefijo.name, e.target.value)
            }
            helperText={dataError.prefijo ? validMessage.required : null}
            error={dataError.prefijo}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl fullWidth size="small">
            <InputLabel id={`label_${CONST.estatus.name}`}>
              {CONST.estatus.label}
            </InputLabel>
            <Select
              id={CONST.estatus.name}
              value={data.estatus}
              required
              labelId={`label_${CONST.estatus.name}`}
              label={CONST.estatus.label}
              onChange={(e) =>
                _handleSetDataField(CONST.estatus.name, Number(e.target.value))
              }
            >
              <MenuItem value={1}>ACTIVO</MenuItem>
              <MenuItem value={2}>BLOQUEADO</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            mr={2}
            saveIcon
          />
          {activo ? (
            <BotonComponent
              click={clearData}
              text="CANCELAR"
              disabled={loadingSave}
              black
              closeIcon
            />
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormOperadoras;
